import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { MetadataState } from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const metadata: Module<MetadataState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
